module.exports = __webpack_public_path__ + "img/bg02.7877e33a.svg";